const ROOT = 'METABASE_';

const actions = {
  LOAD_METABASE_REQUEST: `${ROOT}LOAD_METABASE_REQUEST`,
  LOAD_METABASE_SUCCESS: `${ROOT}LOAD_METABASE_SUCCESS`,
  LOAD_METABASE_ERROR: `${ROOT}LOAD_METABASE_ERROR`,
} as const;

export default actions;
